import React, { useState, useEffect, useMemo } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";


const Context = React.createContext();

export function ApplicationContextProvider({ children }) {
  let navigate = useNavigate();
  const [jwt, setJwt] = useState(() => sessionStorage.getItem("jwt"));
  const [username, setUsername] = useState(() =>
    sessionStorage.getItem("username")
  );
  const [roles, setRoles] = useState(() => {
    const storedRoles = sessionStorage.getItem("roles");
    return storedRoles ? JSON.parse(storedRoles) : [];
  });

  

  const [isLogged, setIsLogged] = useState(() => {
    const token = sessionStorage.getItem("jwt");
    if (!token) return false;

    try {
      const decoded = jwtDecode(token);
      return Date.now() < decoded.exp * 1000; 
    } catch {
      return false;
    }
  });

  // Validate JWT Token
  useEffect(() => {
    if (!jwt) {
      setIsLogged(false);
      return;
    }

    try {
      const decoded = jwtDecode(jwt);
      const isTokenValid = Date.now() < decoded.exp * 1000;
      setIsLogged(isTokenValid);
    } catch {
      setIsLogged(false);
    }
  }, [jwt]);

  useEffect(() => {
    if (!isLogged || !jwt) return;

    try {
      const decoded = jwtDecode(jwt);
      const timeout = decoded.exp * 1000 - Date.now();

      if (timeout <= 0) {
        sessionStorage.clear();
        setJwt(null);
        setIsLogged(false);
        navigate("/login");
        return;
      }

      const timer = setTimeout(() => {
        sessionStorage.clear();
        setJwt(null);
        setIsLogged(false);
        navigate("/login");
      }, timeout);

      return () => clearTimeout(timer); 
    } catch (error) {
      console.error("JWT decode error:", error);
    }
  }, [isLogged, jwt, navigate]);

  const contextValue = useMemo(
    () => ({ isLogged, jwt, username, roles, setIsLogged, setJwt, setUsername, setRoles }),
    [isLogged, jwt, username, roles]
  );

  return (
    <Context.Provider value={contextValue}>{children}</Context.Provider>
  );
}

export default Context;